import { render, staticRenderFns } from "./EditBulkCertificate.vue?vue&type=template&id=ddccccd4"
import script from "./EditBulkCertificate.vue?vue&type=script&lang=js"
export * from "./EditBulkCertificate.vue?vue&type=script&lang=js"
import style0 from "./EditBulkCertificate.vue?vue&type=style&index=0&id=ddccccd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports